import { render, staticRenderFns } from "./index.vue?vue&type=template&id=794f65d2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/index-pc.css?vue&type=style&index=0&id=794f65d2&scoped=true&lang=css&"
import style1 from "../assets/css/index-phone.css?vue&type=style&index=1&id=794f65d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f65d2",
  null
  
)

export default component.exports